<template>
  <div class="brain">
    <div class="debugInfo visible">
      <div id="buildinfo" class="buildinfo"></div>
      <button v-on:click.prevent="toggleDebugPanel">Debug Panel</button>
    </div>
    <div class="debugPanel">
      <div class="debugGroup">
        <div class="progressDivider">
          <div class="debugData">
            <h2>Settings</h2>
            <ul>
              <li>
                <span>isTouchDevice:</span>
                {{ isTouchDevice }}
              </li>
              <li>
                <span>Home Use Token:</span>
                {{ homeUseToken }}
              </li>
              <li>
                <span>Token (Clever User):</span>
                {{ token }}
              </li>
              <li>
                <span>Grade:</span>
                {{ grade }}
              </li>
              <li>
                <span>Student ID:</span>
                {{ studentId }}
              </li>
              <li>
                <span>Classroom ID:</span>
                {{ classroomId }}
              </li>
              <li>
                <span>User First Name:</span>
                {{ firstName }}
              </li>
              <li>
                <span>Product Key:</span>
                {{ productId }}
              </li>
              <li>
                <span>ToolbarMode:</span>
                {{ toolbarMode }}
              </li>
              <li>
                <span>Curriculum Complete:</span>
                {{ curriculumComplete }}
              </li>
              <li>
                <span>Current Theme:</span>
                {{ currentTheme }}
              </li>
              <li>
                <span>Current Week:</span>
                {{ currentWeek }}
              </li>
              <li>
                <span>Current ASN:</span>
                {{ currentASN }}
              </li>
              <li>
                <span>Current activityId:</span>
                {{ activityId }}
              </li>
              <li>
                <span>Current Activity:</span>
                {{ currentActivity }}
              </li>
              <li>
                <span>Active Assessment:</span>
                {{ isActiveAssessment }}
              </li>
            </ul>
          </div>
          <qahelper></qahelper>
        </div>
      </div>
      <div class="debugGroup">
        <h2>Classrooms</h2>
        <div class="classRoomStore">
          <div
            class="classroomItem"
            v-for="(item, index) in classroomsDisplay"
            :key="`classroom-${index}`"
          >
            <p>
              classroomId:
              <span>{{ item.id }}</span>
            </p>
            <p>
              teacher:
              <span>{{ item.teacher.username }}</span>
            </p>
            <p>
              name:
              <span>{{ item.name }}</span>
            </p>
            <p>
              grades:
              <span>{{ item.gradeLevels }}</span>
            </p>
          </div>
        </div>
        <button v-on:click.prevent="clearStore" class="clearStore">Clear Store</button>
      </div>
      <div class="debugGroup">
        <h2>Activity Tester</h2>
        <div></div>
        <button v-on:click.prevent="changeMode('tester')" class="clearStore">Go To Tester</button>
      </div>
      <div class="debugGroup center">
        <button v-on:click.prevent="toggleDebugPanel">Close Panel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import store from 'store';
import qahelper from './qahelper.vue';

export default {
  components: {
    qahelper
  },
  computed: {
    ...mapState('application', ['kwtMode', 'allowDebug']),
    ...mapState('student', [
      'homeUseToken',
      'token',
      'grade',
      'classroomId',
      'firstName',
      'productId'
    ]),
    ...mapState('student', {
      studentId: state => state.id,
      curriculumComplete: ({
        position: { last: { progress: { curriculum: { position, total } = {} } = {} } = {} } = {}
      }) => position && total && position === total,
      currentTheme: ({ position: { next: { theme: { id } = {} } = {} } = {} }) => id || 'bla bla',
      currentWeek: ({ position: { next: { week } = {} } = {} }) => week || -1,
      currentASN: ({ position: { next: { asn } = {} } = {} }) => asn || -1
    }),
    ...mapState('application', {
      isTouchDevice: state => state.device.isMobile,
      toolbarMode: state => state.toolbarMode
    }),
    ...mapState('activity', {
      activityId: ({ data: { activityId } = {} }) => activityId || 0,
      currentActivity: ({ data: { type } = {} }) => type,
      isActiveAssessment: ({ data: { scheduledActivityId } = {} }) => Boolean(scheduledActivityId)
    }),
    classroomsDisplay() {
      return store.get('classrooms');
    }
  },
  methods: {
    ...mapMutations('application', ['setKwtMode']),
    changeMode(mode) {
      this.setKwtMode(mode);
      this.$router.push(mode);
    },
    clearStore() {
      store.clearAll();
    },
    toggleDebugPanel() {
      const dpanel = document.querySelector('.debugPanel');
      dpanel.classList.toggle('visible');
    }
  }
};
</script>
